import { useState, useEffect } from "react";
import styles from "./CookieNotice.module.scss";
import { useTranslation } from "react-i18next";

const CookieNotice: React.FC = () => {
  const { t } = useTranslation('general');
  
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const accepted = localStorage.getItem("cookiesAccepted");
    if (!accepted) {
      setIsVisible(true);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem("cookiesAccepted", "true");
    window.dispatchEvent(new Event("cookiesAccepted"));
    setIsVisible(false);
  };

  if (!isVisible) return null;

  return (
    <div className={styles.cookieContainer}>
        <p className={styles.description}>{t("cookies")} <span className={styles.hintText}>{t("cookies_desc")}</span>
        </p>
        <div className={styles.actionsContainer}>
            <button className={styles.button} onClick={handleAccept}>{t("close")}</button>
            <button className={styles.primaryButton} onClick={handleAccept}>{t("accept")}</button>
        </div>
    </div>
  );
}

export default CookieNotice;